import { Autocomplete, TextField } from '@mui/material';

import { useGetUsersOptions } from '../../../../../common/hooks/useGetUsersOptions';

const InboxResponsibleFilter = ({ value, onChange, disabled }) => {
    const [userOptions] = useGetUsersOptions();

    return (
        <Autocomplete
            value={value}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            options={userOptions}
            getOptionLabel={option => option.fullName || ''}
            renderInput={params => <TextField {...params} label={'Responsible'} />}
            onChange={(_, data) => onChange(data)}
            disabled={disabled}
            fullWidth
        />
    );
};

export default InboxResponsibleFilter;